import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP } from '../constants';

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-20 right-4 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full flex items-center justify-center shadow-xl transition-all hover:scale-110"
      title="WhatsApp"
    >
      <MessageCircle size={26} className="text-white" />
    </a>
  );
}
